'use client'

import { Button } from '@vinted/web-ui'

import { useAuthModal } from '@marketplace-web/registration/identity-feature'

const SignupButton = (props: React.ComponentProps<typeof Button>) => {
  const { openAuthModal } = useAuthModal()

  const handleClick = () => {
    openAuthModal({ isBusiness: true })
  }

  return <Button {...props} styling={Button.Styling.Filled} onClick={handleClick} />
}

export default SignupButton
